import { Grid } from "@mui/material";
import { useSuperAdminSingleOrg } from "../../../../context/SuperAdmin/SingleOrgContext";
import { Spinner } from "../../../Loading/Spinner";
import CreateSuborgModal from "./CreateSuborgModal";
import DeleteSuborgModal from "./DeleteSuborgModal";
import EditSuborgModal from "./EditSuborgModal";
import HeadersSuborgsTable from "./HeadersSuborgsTable";
import SingleOrgSuborgsTable from "./SingleOrgSuborgsTable";

const SingleOrgSuborgs = () => {
  const { isLoadingSuborgs } = useSuperAdminSingleOrg();

  if (isLoadingSuborgs) {
    return <Spinner msg="Cargando por favor espere..." />;
  }

  return (
    <Grid
      container
      spacing={2}
      sx={{
        display: "flex",
        flexDirection: "column",
        marginTop: 3,
        width: "100%",
        marginX: "auto",
        paddingX: 4,
      }}
    >
      {/* Searchbar y crear suborganizacion */}
      <Grid item>
        <HeadersSuborgsTable />
      </Grid>

      {/* Tabla de subprganizaciones */}
      <Grid item>
        <SingleOrgSuborgsTable />
      </Grid>

      <Grid item>
        <CreateSuborgModal />
      </Grid>

      <Grid item>
        <EditSuborgModal />
      </Grid>

      {/* Modal para borrar suborganizacion */}
      <Grid item>
        <DeleteSuborgModal />
      </Grid>
    </Grid>
  );
};

export default SingleOrgSuborgs;
